import tableInfo from './tableInfo';
import getLocation from './getLocation';
export default {
	tableInfo,
	getLocation
};